import {effect, Injectable, signal} from '@angular/core';
import {ImsDocumentDetaiLDownload} from '../models/output.model';
import {Base64Model} from '../models/input.model';




@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  isLoading = signal(false);
  get pagination() {
    const params = JSON.stringify({offset: 0, limit: 10})
    return JSON.parse(localStorage.getItem('paging') ||  params )
  } //= signal<any>(JSON.parse(localStorage.getItem('paging') || "{'offset': 0, 'limit': 10}"));
  constructor(
  ) {
  }

  onFileSelected(event: Event, selectedFiles: File[],base64Files: Base64Model[] ) {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files.length > 0) {
      selectedFiles = Array.from(input.files);

      selectedFiles.forEach(file => {

        this.readBase64File(file).then(value => {
          base64Files.push({
            filename: file.name,
            base64: (value as string).split(',')[1]
          })
        })
      })
    }

  }

  async readBase64File(file: File) {
    return await new Promise((resolve => {
      let reader = new FileReader();
      reader.onload = (e) => resolve(reader.result);
      reader.readAsDataURL(file);
    }));
  }

  transformBlobToLink(response: ImsDocumentDetaiLDownload, type: string) {
    const fileBase64 = response.data.base64;
    const fileName = response.data.filename;
    const mimeType = type.toLowerCase() || "application/octet-stream";

    const byteCharacters = atob(fileBase64);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += 512) {
      const slice = byteCharacters.slice(offset, offset + 512);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, {type: mimeType});

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(link.href);
  }



}
